import { EditBase, Form } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { AutomationRuleInputs } from "./AutomationRuleInputs";

export const AutomationRuleEdit = () => (
  <EditBase redirect="list">
    <div className="mt-2 flex max-w-md">
      <Form className="flex-1">
        <Card>
          <CardContent>
            <AutomationRuleInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
    </div>
  </EditBase>
);
